import Joi from '@hapi/joi'
import { PatrimonyWithAccountRequest } from 'services/patrimony/types'
import { patrimonyPayloadSchema } from 'shared/schemas'

export const updatePatrimonySchema = Joi.object<PatrimonyWithAccountRequest>({
  patrimony: patrimonyPayloadSchema.required(),
  customerId: Joi.string().uuid().optional(),
  hasAccount: Joi.boolean().optional(),
})
